/**
 * Formats the deliveryLocation string by removing the word "office" if it exists.
 *
 * The function performs the following operations:
 * - Trims leading and trailing whitespace from the deliveryLocation string.
 * - Checks if the deliveryLocation contains the word "office" (case insensitive).
 * - If "office" is found, it removes the word "office" and any trailing spaces.
 * - Returns the formatted deliveryLocation string.
 *
 * @param {string} deliveryLocation - The deliveryLocation string to format.
 * @returns {string} The formatted deliveryLocation string.
 */
export function formatDeliveryLocation(deliveryLocation: string): string {
    if (!deliveryLocation || deliveryLocation === '') {
        return ''; // Return an empty string if the deliveryLocation is null or empty
    }

    const formattedDeliveryLocation = deliveryLocation.trim(); // Remove leading and trailing whitespace

    // Check if the deliveryLocation contains the word "office" (case insensitive)
    if (formattedDeliveryLocation.toLowerCase().includes('office')) {
        // Remove the word "office" and any trailing spaces
        return formattedDeliveryLocation.replace(/office\s*$/i, '').trim();
    }

    return formattedDeliveryLocation; // Return the original deliveryLocation if "office" is not found
}
